import { Link } from "react-router-dom";

export default function DestinationCard({ destination, size = "md" }) {
  const heightCls = size === "lg" ? "aspect-[4/5]" : size === "sm" ? "aspect-[5/4]" : "aspect-[4/5]";
  return (
    <Link
      to={`/destinations/${destination.key}`}
      data-testid={`destination-card-${destination.key}`}
      className={`group relative block overflow-hidden ${heightCls} bg-charcoal`}
    >
      <img
        src={destination.image}
        alt={destination.name}
        className="absolute inset-0 w-full h-full object-cover opacity-85 group-hover:opacity-100 transition-all duration-[1100ms] group-hover:scale-[1.06]"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/20 to-transparent" />
      <div className="relative h-full flex flex-col justify-end p-6 md:p-8 text-sand">
        <div className="overline text-sand/70">{destination.state}</div>
        <div className="font-serif text-3xl md:text-4xl leading-none mt-2">{destination.name}</div>
        <div className="text-sand/75 text-sm mt-2 max-w-[24ch]">{destination.tagline}</div>
      </div>
    </Link>
  );
}
